import { Component, Injectable } from '@angular/core';

@Injectable()
export class FormioLoader {
  public loading: boolean = true;
}

